import { useCallback } from 'react';
import type { AnalyticsTrafficDashboard } from '@/types/analytics/dashboard';
import { getTrafficDashboard } from '@/services/analytics/dashboard.service';
import { useAnalyticsSection } from './use-analytics-section';

const EMPTY: AnalyticsTrafficDashboard = {
  pageviews: 0,
  returnRateLabel: '—',
  desktopPct: 0,
  mobilePct: 0,
  pageviewsTrend: null,
  returnTrend: null,
  visitsSeries: [],
  sources: [],
  devices: [],
};

export function useAnalyticsTraffic() {
  const loader = useCallback(() => getTrafficDashboard(), []);
  return useAnalyticsSection(loader, EMPTY);
}
